module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-space-between px-3 pt-3 font-weight-600 font-size-18 border-bottom pb-3 mt-5"
  }, [_c('div', [_vm._v("Daftar Konsultan")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center gap-10"
  }, [_c('v-btn', {
    staticClass: "white--text px-3",
    attrs: {
      "color": "blew",
      "depressed": "",
      "to": "/konsul/consultant-form"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Tambah Konsultan\n            ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text px-3",
    attrs: {
      "color": "blew",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetchData()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-cached")]), _vm._v("\n                Sinkronisasi Data\n            ")], 1), _vm._v(" "), _c('v-card', {
    staticClass: "d-flex align-center py-1 px-2 gap-5",
    staticStyle: {
      "width": "180px",
      "line-height": "0.8em",
      "border": "1.5px solid #eeeeee"
    },
    attrs: {
      "outlined": "",
      "color": "#f9fafb"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "blew",
      "small": ""
    }
  }, [_vm._v("mdi-information")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-12"
  }, [_c('div', {
    staticClass: "blew--text font-weight-bold"
  }, [_vm._v("\n                        Terakhir Diupdate\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "darkgrey--text font-size-11"
  }, [_vm._v("\n                        " + _vm._s(_vm.updated_date) + "\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex px-3 py-4 gap-10 border-bottom"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Ketik kata kunci dan tekan enter",
      "dense": "",
      "outlined": "",
      "small": "",
      "hide-details": "",
      "append-icon": "mdi-magnify"
    },
    model: {
      value: (_vm.search_value),
      callback: function($$v) {
        _vm.search_value = $$v
      },
      expression: "search_value"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.data,
      "item-key": "id",
      "loading": _vm.loading,
      "search": _vm.search_value,
      "no-data-text": "Data konsultan tidak tersedia"
    },
    scopedSlots: _vm._u([{
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-menu', {
          attrs: {
            "offset-y": "",
            "transition": "slide-y-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                attrs: {
                  "text": ""
                }
              }, on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-item-group', [_c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.openDetail(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "#6173e6"
          }
        }, [_vm._v("\n                                        mdi-forum\n                                    ")]), _vm._v("\n                                    Riwayat Konsul\n                                ")], 1)], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$router.push(
                ("/konsul/consultant-form?id=" + (item.id))
              )
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("\n                                        mdi-pencil-circle\n                                    ")]), _vm._v("\n                                    Edit\n                                ")], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.mapel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                " + _vm._s(item.mapel.map(function (m) { return m.mapel_name; }).join(", ")) + "\n            ")])]
      }
    }, {
      key: "item.online_status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.online_status === 'offline') ? _c('v-chip', {
          staticClass: "font-weight-600 pl-0",
          attrs: {
            "small": "",
            "color": "#d7dfe9",
            "text-color": "#afbaca"
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "-3px"
          }
        }, [_vm._v("mdi-circle-medium")]), _vm._v("\n                Offline\n            ")], 1) : _vm._e(), _vm._v(" "), (item.online_status === 'online') ? _c('v-chip', {
          staticClass: "font-weight-600 pl-0",
          attrs: {
            "small": "",
            "color": "#e2f5ea",
            "text-color": "#00cf3f"
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "-3px"
          }
        }, [_vm._v("mdi-circle-medium")]), _vm._v("\n                Online\n            ")], 1) : _vm._e(), _vm._v(" "), (item.online_status === 'busy') ? _c('v-chip', {
          staticClass: "font-weight-600 pl-0",
          attrs: {
            "small": "",
            "color": "#ffcccf",
            "text-color": "#eb3123"
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "-3px"
          }
        }, [_vm._v("mdi-circle-medium")]), _vm._v("\n                Sibuk\n            ")], 1) : _vm._e()]
      }
    }, {
      key: "item.consultant_status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.consultant_status) ? _c('v-chip', {
          staticClass: "font-weight-600 pl-0",
          attrs: {
            "small": "",
            "color": "#e2f5ea",
            "text-color": "#00cf3f"
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "-3px"
          }
        }, [_vm._v("mdi-circle-medium")]), _vm._v("\n                Aktif\n            ")], 1) : _c('v-chip', {
          staticClass: "font-weight-600 pl-0",
          attrs: {
            "small": "",
            "color": "#d7dfe9",
            "text-color": "#afbaca"
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "-3px"
          }
        }, [_vm._v("mdi-circle-medium")]), _vm._v("\n                Nonaktif\n            ")], 1)]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('p', {
          staticClass: "my-2"
        }, [_vm._v("Hasil pencarian tidak ditemukan.")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.datatable),
      callback: function($$v) {
        _vm.datatable = $$v
      },
      expression: "datatable"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f458b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/components/ConsultantManagementTable.vue
// module id = 1584
// module chunks = 1